"use client";

import type React from "react";
import {
  ConsentTogglesVisual,
  KycScanVisual,
  SubUsersVisual,
  SupportChatVisual,
} from "./small-feature-visuals";

/* Supporting features shown as the row of smaller cards, each with an ambient
   looping visual instead of an icon. The two flagship features (Real-time
   Dashboard, Uptime) are rendered as large cards with visuals directly in
   index.tsx. */
export const smallFeatures: {
  Visual: React.ComponentType;
  title: string;
  description: string;
}[] = [
  {
    Visual: ConsentTogglesVisual,
    title: "Ethically Sourced IPs",
    description:
      "Every IP in our network is opt-in. Real users voluntarily share bandwidth with strict consent across all devices.",
  },
  {
    Visual: KycScanVisual,
    title: "KYC & Compliance",
    description:
      "We require KYC (Know Your Customer) verification from all customers and maintain a strict acceptable-use policy.",
  },
  {
    Visual: SupportChatVisual,
    title: "Dedicated Support",
    description:
      "Premium support via live chat and email. Enterprise plans come with a dedicated account manager.",
  },
  {
    Visual: SubUsersVisual,
    title: "Sub-user Management",
    description:
      "Create sub-users on the account level or access points/proxy users to separate proxy usage.",
  },
];
